import { getAppTimezone } from "./useBrand";

export const money = (v) =>
  `$${Number(v || 0).toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Stored timestamps are UTC (ISO). Render them as a local clock time in the firm's time zone.
export const fmtDateTime = (v, empty = "") => {
  if (!v) return empty;
  let s = String(v);
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(s)) s += "Z";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(v);
  return new Intl.DateTimeFormat("en-US", {
    timeZone: getAppTimezone(), year: "numeric", month: "short", day: "numeric",
    hour: "numeric", minute: "2-digit", timeZoneName: "short",
  }).format(d);
};

export const TIMEZONES = [
  ["America/Toronto", "Eastern (Toronto / Ottawa)"],
  ["America/Halifax", "Atlantic (Halifax)"],
  ["America/St_Johns", "Newfoundland (St. John's)"],
  ["America/Winnipeg", "Central (Winnipeg)"],
  ["America/Regina", "Central – no DST (Regina)"],
  ["America/Edmonton", "Mountain (Edmonton / Calgary)"],
  ["America/Vancouver", "Pacific (Vancouver)"],
  ["UTC", "UTC"],
];

export const FREQ_LABELS = {
  weekly: "Weekly",
  biweekly: "Bi-weekly",
  semimonthly: "Semi-monthly",
  monthly: "Monthly",
};
